// extracted by mini-css-extract-plugin
export var content = "content-module--content--4ajgH";
export var sectionContent = "content-module--sectionContent--eHVOH";